import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
import * as AWSCognito from 'amazon-cognito-identity-js';
import { environment } from '../../../environments/environment';
import { async } from '@angular/core/testing';
import { UserService } from './user.service';
import { RedirectModel } from '../models/redirect-model';
import { UserModel, AddressModel } from '../models/user-model';
import { CognitoFederatedIdentity } from '../models/cognito-model';
import { SentryService } from './sentry.service';
// Services
// Models

export interface PoolDataInterface {
  UserPoolId: string;
  ClientId: string;
  Storage?: any;
}

export interface CognitoSession {
  idToken: {
    jwtToken: string;
    payload: any
  };
  refreshToken: {
    token: string;
  };
  accessToken?: {
    jwtToken: string;
    payload: any;
  };
  clockDrift?: any;
}

@Injectable({
  providedIn: 'root'
})
export class CognitoService {

  // AWS.config.region = 'us-east-1';
  poolData: PoolDataInterface;
  userPool: AWSCognito.CognitoUserPool;

  constructor(public userService: UserService, public sentryService: SentryService) {
    try {
    } catch (error) {
      this.sentryService.errorHandling(error, 'cognito-service', error.error.message);
    }
  }

  initCognitoUserPool(rememberMe?: string) {
    if (!this.poolData) {
      if (rememberMe !== undefined) {
        if (rememberMe === 'true') {
          this.poolData = {
            UserPoolId: environment.cognitoConf.cognito.cognitoPoolId,
            ClientId: environment.cognitoConf.cognito.cognitoClientPoolId,
            // Storage: new AWSCognito.CookieStorage({domain: '.wonderbnb.com'})
          };
        } else {
          this.poolData = {
            UserPoolId: environment.cognitoConf.cognito.cognitoPoolId,
            ClientId: environment.cognitoConf.cognito.cognitoClientPoolIdShortToken,
            // Storage: new AWSCognito.CookieStorage({domain: '.wonderbnb.com'})
          };
        }
      }
      else if (localStorage.getItem('rememberMe') === 'true') {
        this.poolData = {
          UserPoolId: environment.cognitoConf.cognito.cognitoPoolId,
          ClientId: environment.cognitoConf.cognito.cognitoClientPoolId,
          // Storage: new AWSCognito.CookieStorage({domain: '.wonderbnb.com'})
        };
      } else {
        this.poolData = {
          UserPoolId: environment.cognitoConf.cognito.cognitoPoolId,
          ClientId: environment.cognitoConf.cognito.cognitoClientPoolIdShortToken,
          // Storage: new AWSCognito.CookieStorage({domain: '.wonderbnb.com'})
        };
      }

      this.userPool = new AWSCognito.CognitoUserPool(this.poolData);
    }
  }

  formatCognitoData(cognitoSession: any): UserModel {
    try {
      // formatCognitoData(cognitoSession: CognitoSession): UserModel {
      const cognitoUsername: string = cognitoSession.idToken.payload['cognito:username'];
      const email: string = cognitoSession.idToken.payload['email'];
      const accessToken: string = cognitoSession.idToken.jwtToken;
      const idToken: any = cognitoSession.getIdToken().getJwtToken();
      const refreshToken: string = cognitoSession.refreshToken.token;
      const name: string = cognitoSession.idToken.payload['name'];
      const phone: string = cognitoSession.idToken.payload['phone_number'];
      let userAddress: AddressModel;
      if (cognitoSession.idToken.payload['address'] && cognitoSession.idToken.payload['address'] !== '') {
        userAddress = (typeof cognitoSession.idToken.payload['address'].formatted === 'object') ? JSON.parse(cognitoSession.idToken.payload['address'].formatted) :
          cognitoSession.idToken.payload['address'].formatted;
      } else { userAddress = null; }
      // const address: any = (cognitoSession.idToken.payload['address']) ?
      // JSON.parse(cognitoSession.idToken.payload['address']) : '';
      const companyName: string = cognitoSession.idToken.payload['custom:company-name'];
      const notifications: boolean = (typeof cognitoSession.idToken.payload['custom:notifications'] === 'object') ? JSON.parse(cognitoSession.idToken.payload['custom:notifications']) :
        cognitoSession.idToken.payload['custom:notifications'];

      const userData = {
        cognitoUsername,
        email,
        name,
        phone,
        role: '', // Must update the role inbetween the create/update operations ----
        accessToken,
        idToken,
        refreshToken,
        companyName,
        notifications,
        address: userAddress,
      };
      return userData;
    } catch (error) {
      this.sentryService.errorHandling(error, 'cognito-service', error.error.message);
    }
  }
  /**
   *
   * @param email
   * @param tokens
   */
  authWithTokens(cognitoFederatedIdentity: CognitoFederatedIdentity): Promise<any> {
    try {
      return new Promise((resolve, reject) => {
        this.initCognitoUserPool();
        const AccessToken = new AWSCognito.CognitoAccessToken({ AccessToken: cognitoFederatedIdentity ? cognitoFederatedIdentity.accessToken : '' });
        const IdToken = new AWSCognito.CognitoIdToken({ IdToken: cognitoFederatedIdentity ? cognitoFederatedIdentity.idToken : '' });
        const RefreshToken = new AWSCognito.CognitoRefreshToken({ RefreshToken: cognitoFederatedIdentity ? cognitoFederatedIdentity.refreshToken : '' });

        const sessionData = {
          IdToken,
          AccessToken,
          RefreshToken,
          deviceKey: "-aqZ2H6mM",
          deviceGroupKey: "us-east-1_b3f3084b-f3ce-44ed-ae72-025a2ec1231f"
        };
        const userSession = new AWSCognito.CognitoUserSession(sessionData);

        const userData = {
          Username: cognitoFederatedIdentity.email,
          Pool: this.userPool
        };

        const cognitoUser = new AWSCognito.CognitoUser(userData);
        cognitoUser.setSignInUserSession(userSession);
        cognitoUser.getSession(async (err, session) => {
          if (err) {
            resolve(false);
          }
          if (session && session.isValid()) {

            // Update attributes or whatever else you want to do.
            const connectedUserData = await this.getConnectedUserData({ accessToken: session.getIdToken().getJwtToken() });
            // Updating App State with user data
            const resultUserData: UserModel = { ...this.formatCognitoData(session), ...connectedUserData };
            this.userService.updateUserData(resultUserData);
            if (typeof Storage != "undefined") {
              localStorage.setItem(`CognitoIdentityServiceProvider.${this.userPool.getClientId()}.${cognitoFederatedIdentity.email}.deviceKey`, cognitoFederatedIdentity.deviceKey)
              localStorage.setItem(`CognitoIdentityServiceProvider.${this.userPool.getClientId()}.${cognitoFederatedIdentity.email}.deviceGroupKey`, cognitoFederatedIdentity.deviceGroupKey)
            } else {
              throw ('Sorry! Your browser not support web storage')
            }
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    } catch (error) {
      this.sentryService.errorHandling(error, 'cognito-service', error.error.message);
    }
  }

  /**
   * Get user data from API
   */
  getConnectedUserData(resultUserData) {
    try {
      this.initCognitoUserPool();
      return this.userService.getUserByEmail(resultUserData).toPromise();
    } catch (error) {
      this.sentryService.errorHandling(error, 'cognito-service', error.error.message);
    }
  }

  // ######################## Refresh Token, that expires in 60 minutes  ##########################

  renew(refreshToken: string): Promise<any> {

    try {
      this.initCognitoUserPool();
      const userPool = this.userPool;
      const cognitoUser = userPool.getCurrentUser();

      return new Promise((resolve, reject) => {

        const RefreshToken = new AWSCognito.CognitoRefreshToken({ RefreshToken: refreshToken });

        cognitoUser.refreshSession(RefreshToken, (err, session) => {
          if (err) {
            reject(err);
          } else {
            const retObj = {
              status: 'SUCCESS',
              access_token: session ? session.accessToken.jwtToken : '',
              id_token: session ? session.idToken.jwtToken : '',
              refresh_token: session ? session.refreshToken.token : '',
            };
            resolve(retObj);
          }
        });

      });
    } catch (error) {
      this.sentryService.errorHandling(error, 'cognito-service', error.error.message);
    }

  }


  // Check if session is declared, returns true if it is, renews if expired and returns true, otherwise returns error with 'not_logged_in'

  checkSessionAndRenew(): Promise<boolean> {
    try {
      this.initCognitoUserPool();
      const userPool = this.userPool;
      const cognitoUser = userPool.getCurrentUser();

      return new Promise((resolve, reject) => {
        if (cognitoUser == null || cognitoUser === undefined) {
          reject('not_logged_in');
        } else {
          cognitoUser.getSession(async (err, session) => {
            if (err) {
              reject(err.message || JSON.stringify(err));
            } else {
              const connectedUserData = await this.getConnectedUserData({ accessToken: session.getIdToken().getJwtToken() });
              // Updating App State with user data
              const resultUserData: UserModel = { ...this.formatCognitoData(session), ...connectedUserData };
              this.userService.updateUserData(resultUserData);
              const sessionExpirationTimeSecs = session.accessToken.payload.exp;
              const timeNowSecs = (new Date().getTime() / 1000) + 300;
              // Check if token has expired or will expire within 5 minutes, in which case renew it
              if (!session.isValid() || sessionExpirationTimeSecs <= timeNowSecs) {
                const refreshToken = session.refreshToken.token;
                this.renew(refreshToken)
                  .then((res) => { resolve(true); },
                    (error) => { reject(error.message || error); });
              } else {
                // Otherwise, session is OK and not expiring, so say that it is OK.
                resolve(false);
              }

            }
          });
        }

      });
    } catch (error) {
      this.sentryService.errorHandling(error, 'cognito-service', error.error.message);
    }
  }
  // Check if session is declared, returns true if it is, renews if expired and returns true, otherwise returns error with 'not_logged_in'

  renewTest(): Promise<boolean> {
    try {
      this.initCognitoUserPool();
      const userPool = this.userPool;
      const cognitoUser = userPool.getCurrentUser();

      return new Promise((resolve, reject) => {
        if (cognitoUser == null || cognitoUser === undefined) {
          reject('not_logged_in');
        } else {
          cognitoUser.getSession(async (err, session) => {
            if (err) {
              reject(err.message || JSON.stringify(err));
            } else {
              const refreshToken = session.refreshToken.token;
              this.renew(refreshToken)
                .then((res) => { resolve(true); },
                  (error) => { reject(error.message || error); });
            }
          });
        }

      });
    } catch (error) {
      this.sentryService.errorHandling(error, 'cognito-service', error.error.message);
    }
  }


  signOut(): Promise<void> {
    try {
      this.initCognitoUserPool();
      const userPool = this.userPool;
      const cognitoUser = userPool.getCurrentUser();
      return new Promise((resolve, reject) => {
        if (cognitoUser == null) {
          reject('Error during Signout: Cognito User isn\'t authenticated');
        } else {
          this.userService.clearUserData();
          cognitoUser.signOut();
          resolve();
        }
        // cognitoUser.signOut(); // for signing out only from the app
        /*
        cognitoUser.globalSignOut({
            onSuccess: function (result) {
                resolve();
            },
            onFailure: (err) => {
                console.error('error during global Signout:', err.message);
                reject(err);
            }
        });
    */
      });
    } catch (error) {
      this.sentryService.errorHandling(error, 'cognito-service', error.error.message);
    }

  }

  getDevice(): Object {
    try {
      if (typeof Storage !== "undefined") {
        const LastAuthUser = localStorage.getItem(`CognitoIdentityServiceProvider.${this.userPool.getClientId()}.LastAuthUser`);
        const deviceGroupKey = localStorage.getItem(`CognitoIdentityServiceProvider.${this.userPool.getClientId()}.${LastAuthUser}.deviceGroupKey`);
        const deviceKey = localStorage.getItem(`CognitoIdentityServiceProvider.${this.userPool.getClientId()}.${LastAuthUser}.deviceKey`);
        return {
          deviceKey,
          deviceGroupKey
        }
      }
      else {
        throw ('Sorry! Your browser not support web storage')
      }
    } catch (error) {
      this.sentryService.errorHandling(error, 'cognito-service', error.error.message);
    }
  }
}
